import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const STORAGE_KEY = 'alitero-cookie-consent';

const getInitialVisibility = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const alreadyAccepted = localStorage.getItem(STORAGE_KEY);
  return !alreadyAccepted;
};

const CookieBanner = () => {
  const { currentLanguage } = useLanguage();
  const translation = translations[currentLanguage]?.cookieBanner;
  const [isVisible, setIsVisible] = useState(getInitialVisibility);

  if (!translation || !isVisible) {
    return null;
  }

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setIsVisible(false);
  };

  return (
    <div
      className="fixed bottom-4 left-1/2 z-50 w-full max-w-4xl -translate-x-1/2 px-4"
      role="status"
      aria-live="polite"
    >
      <div className="rounded-2xl border border-gray-200 bg-white/95 p-5 shadow-2xl shadow-slate-900/5 backdrop-blur">
        <div className="flex flex-col gap-4 md:flex-row md:items-center">
          <div className="flex-1 text-sm text-gray-700">
            <p className="text-base font-semibold text-gray-900">{translation.title}</p>
            <p className="mt-1">{translation.message}</p>
            <Link
              to="/privacy"
              className="mt-2 inline-block text-sm font-semibold text-blue-600 hover:underline"
            >
              {translation.privacy}
            </Link>
          </div>
          <button
            type="button"
            onClick={handleAccept}
            className="inline-flex items-center justify-center rounded-full bg-white px-4 py-2 text-sm font-semibold text-blue-600 shadow-lg shadow-blue-200/50 transition hover:bg-blue-600 hover:text-white hover:shadow-blue-600/30 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500"
          >
            {translation.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
